import clsx from "clsx";

const RoastLevelHorizontal = ({
  roastLevel,
  activeCollectionHandler = () => {},
  activeCollection,
}) => {
  let activeBgHexColor = "";
  let activeTextHexColor = "";

  switch (activeCollection.collectionHandle) {
    case "bright-light":
      activeBgHexColor = "#ffd98a";
      activeTextHexColor = "#4d4e53";
      break;
    case "light":
      activeBgHexColor = "#f8be00";
      activeTextHexColor = "#4d4e53";
      break;
    case "medium":
      activeBgHexColor = "#d48232";
      activeTextHexColor = "#4d4e53";
      break;
    case "full-medium":
      activeBgHexColor = "#bc4700";
      activeTextHexColor = "#fff";
      break;
    case "dark":
      activeBgHexColor = "#8c88a3";
      activeTextHexColor = "#fff";
      break;
    case "beyond-dark":
      activeBgHexColor = "#003b4d";
      activeTextHexColor = "#fff";
      break;
    default:
      activeBgHexColor = "#fff";
      activeTextHexColor = "#4d4e53";
  }

  return (
    <div className="relative">
      <span
        className={clsx(
          "flex flex-col justify-center items-center w-full text-center font-semibold px-4 py-2 uppercase transition cursor-pointer"
        )}
        onClick={activeCollectionHandler}
        roastlevel={roastLevel}>
        <span
          className="inline-flex w-[16px] h-[16px] md:w-[20px] md:h-[20px] rounded-full border-2 border-none"
          roastlevel={roastLevel}
          onClick={activeCollectionHandler}></span>
      </span>
    </div>
  );
};

export default RoastLevelHorizontal;
